import request from "@/utils/requestJSON";

export function getHomeIndex() {
  return request({
    url: "/storage/Home/index.json",
    method: "get",
  });
}

// 建議改成通用函式
export function getAlert(q = 1, config = {}) {
  return request({
    url: `/api/Alert?q=${encodeURIComponent(q)}`, // ← 先保險直串
    method: 'get',
    ...config,
  })
}